import { createFileRoute, Outlet } from "@tanstack/react-router";

import { LandingHeader } from "@/components/index/landing-header";

export const Route = createFileRoute("/(landing)")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<main className="min-h-screen bg-background text-foreground">
			<LandingHeader />
			<Outlet />
		</main>
	);
}
